module.exports = __webpack_public_path__ + "static/media/img-1.eacb36d5.jpg";